import { createFileRoute } from "@tanstack/react-router";
import Page from "@project/admin/pages/modules/community/event-categories";

export const Route = createFileRoute("/admin/_modules/event-categories")({
  component: Page,
});
